import { CANCELLATION_REASON_CODES, CancellationReasonCode } from '../class/cancellation-reason';
import { Currency } from '../enum/currency';

export const PURCHASE_WITHDRAWAL_PERIOD_DAYS = 14;

export const PURCHASE_WITHDRAWAL_REASONS: CancellationReasonCode[] = CANCELLATION_REASON_CODES;

export type PurchaseWithdrawalReason = CancellationReasonCode;

export interface ProductRegretSettlement {
  productId: string;
  paymentId?: string;
  settlementType: string;
  refundAmount: number;
  creditAmount: number;
  moneyRefundAmount: number;
  unpaidCreditAmount: number;
  usedAmount: number;
  alreadyPaid: boolean;
}

export interface ProductRegretPreview {
  refundAmount: number;
  usedAmount: number;
  creditAmount: number;
  moneyRefundAmount: number;
  unpaidCreditAmount: number;
  settlementType: string;
  withinQualifyingPeriod: boolean;
  createsNewInvoice: boolean;
  newInvoiceAmount: number;
  currency: Currency;
  affectedChildProductIds: string[];
  products: ProductRegretSettlement[];
  regretDaysRemaining: number;
}

export type ProductWithdrawalPreview = ProductRegretPreview;
